/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../inputs/phone-number-field/phone-number-field.component.ngfactory';
import * as import2 from '@angular/forms';
import * as import3 from '../../inputs/phone-number-field/phone-number.directive';
import * as import4 from '../../inputs/phone-number-field/phone-number-field.component';
import * as import5 from '../../inputs/email-field/email-field.component.ngfactory';
import * as import6 from '../../inputs/email-field/email.directive';
import * as import7 from '../../inputs/email-field/email-field.component';
import * as import8 from '../../inputs/text-field/text-field.component.ngfactory';
import * as import9 from '../../inputs/text-field/text-field.component';
import * as import10 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import11 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import12 from '../../orchestration/page';
import * as import13 from '../../orchestration/navigation.service';
import * as import14 from './marketing-entry-page.component';
import * as import15 from '../../inputs/form/form.component.ngfactory';
import * as import16 from '../../inputs/form/form.component';
import * as import17 from '../../notification/notification.service';
import * as import18 from '@angular/common';
import * as import19 from '../../buttons/button/button.component.ngfactory';
import * as import20 from '../../buttons/button/button.component';
import * as import21 from '../../orchestration/session.model';
import * as import22 from '../../orchestration/responsive.service';
import * as import23 from '../../page-layout/page-footer-control.directive';
import * as import24 from '../../orchestration/navigation-params';
const styles_MarketingEntryPageComponent:any[] = ([] as any[]);
export const RenderType_MarketingEntryPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MarketingEntryPageComponent,
  data: {}
}
);
function View_MarketingEntryPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-phone-number-field',[
      [
        'name',
        'mobilePhone'
      ]
      ,
      [
        'woa-phone-number',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.mobilePhone = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_PhoneNumberFieldComponent_0,import1.RenderType_PhoneNumberFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import2.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
    import0.ɵdid(16384,(null as any),0,import3.PhoneNumberDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import2.RequiredValidator,
      import3.PhoneNumberDirective
    ]
    ),
      import0.ɵdid(180224,(null as any),0,import4.PhoneNumberFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import4.PhoneNumberFieldComponent]),
      import0.ɵdid(671744,[[
        5,
        4
      ]
    ],0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:boolean = !co.showEmail;
    ck(v,1,0,currVal_8);
    const currVal_9:any = 'woa.label.common.mobile';
    ck(v,4,0,currVal_9);
    const currVal_10:any = 'mobilePhone';
    const currVal_11:any = co.mobilePhone;
    ck(v,6,0,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_1:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_MarketingEntryPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-email-field',[
      [
        'name',
        'email'
      ]
      ,
      [
        'woa-email',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.email = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_EmailFieldComponent_0,import5.RenderType_EmailFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import2.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
    import0.ɵdid(16384,(null as any),0,import6.EmailDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import2.RequiredValidator,
      import6.EmailDirective
    ]
    ),
      import0.ɵdid(180224,(null as any),0,import7.EmailFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.EmailFieldComponent]),
      import0.ɵdid(671744,[[
        5,
        4
      ]
    ],0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:boolean = !co.showMobilePhone;
    ck(v,1,0,currVal_8);
    const currVal_9:any = 'woa.label.common.email';
    ck(v,4,0,currVal_9);
    const currVal_10:any = 'email';
    const currVal_11:any = co.email;
    ck(v,6,0,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_1:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_MarketingEntryPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'woa-text-field',[[
        'name',
        'postCode'
      ]
    ],[
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.postCode = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_TextFieldComponent_0,import8.RenderType_TextFieldComponent)),
      import0.ɵdid(540672,(null as any),0,import2.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.MaxLengthValidator]),
    import0.ɵdid(180224,(null as any),0,import9.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import9.TextFieldComponent]),
      import0.ɵdid(671744,[[
        5,
        4
      ]
    ],0,import2.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import0.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = '10';
    ck(v,1,0,currVal_8);
    const currVal_9:any = 'woa.label.address.postCode';
    const currVal_10:any = 'postal-code';
    const currVal_11:any = '10';
    const currVal_12:any = false;
    ck(v,3,0,currVal_9,currVal_10,currVal_11,currVal_12);
    const currVal_13:any = 'postCode';
    const currVal_14:any = co.postCode;
    ck(v,5,0,currVal_13,currVal_14);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).maxlength? import0.ɵnov(v,1).maxlength: (null as any));
    const currVal_1:any = import0.ɵnov(v,7).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,7).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,7).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,7).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,7).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,7).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,7).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_MarketingEntryPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    import0.ɵqud(402653184,2,{form: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),25,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import10.View_ModalPageLayoutComponent_0,import10.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import11.ModalPageLayoutComponent,[
      import12.Page,
      import13.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      contentText: [
        1,
        'contentText'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,3,{contentMessages: 1}),
    import0.ɵqud(603979776,4,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import12.PageLayout,(null as any),[import11.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,14,'woa-form',([] as any[]),(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.MarketingEntryPageComponent = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.confirmDetails()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import15.View_FormComponent_0,import15.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import16.FormComponent,[import17.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,5,{models: 1}),
    import0.ɵqud(603979776,6,{modelContainers: 1}),
    import0.ɵprd(5120,(null as any),import16.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import16.FormComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_MarketingEntryPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import18.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_MarketingEntryPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import18.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_MarketingEntryPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import18.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),7,2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import14.MarketingEntryPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,25).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_ButtonComponent_0,import19.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import20.ButtonComponent,[
      import0.ElementRef,
      import21.SessionModel,
      import0.ChangeDetectorRef,
      import22.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import23.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import14.MarketingEntryPageComponent = v.component;
    const currVal_0:any = 'woa.heading.marketing.title';
    const currVal_1:any = co.instructions;
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = co.showMobilePhone;
    ck(v,15,0,currVal_2);
    const currVal_3:any = co.showEmail;
    ck(v,18,0,currVal_3);
    const currVal_4:any = co.showPostCode;
    ck(v,21,0,currVal_4);
    const currVal_32:any = 'woa.button.marketing.marketingOptIn';
    ck(v,25,0,currVal_32);
  },(ck,v) => {
    const currVal_5:any = import0.ɵnov(v,25).overrideFlatBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,25).overrideFlatForegroundColor;
    const currVal_7:any = import0.ɵnov(v,25).overrideOutlineBackgroundColor;
    const currVal_8:any = import0.ɵnov(v,25).overrideOutlineForegroundColor;
    const currVal_9:any = import0.ɵnov(v,25).overrideOutlineBorderColor;
    const currVal_10:any = import0.ɵnov(v,25).overrideRaisedBackgroundColor;
    const currVal_11:any = import0.ɵnov(v,25).overrideRaisedForegroundColor;
    const currVal_12:any = import0.ɵnov(v,25).disabled;
    const currVal_13:any = import0.ɵnov(v,25).invisible;
    const currVal_14:any = import0.ɵnov(v,25).hovered;
    const currVal_15:any = import0.ɵnov(v,25).native;
    const currVal_16:any = import0.ɵnov(v,25).button;
    const currVal_17:any = import0.ɵnov(v,25).firstTier;
    const currVal_18:any = import0.ɵnov(v,25).secondTier;
    const currVal_19:any = import0.ɵnov(v,25).highProminence;
    const currVal_20:any = import0.ɵnov(v,25).lowProminence;
    const currVal_21:any = import0.ɵnov(v,25).affirmativeConnotation;
    const currVal_22:any = import0.ɵnov(v,25).dissuasiveConnotation;
    const currVal_23:any = import0.ɵnov(v,25).negativeConnotation;
    const currVal_24:any = import0.ɵnov(v,25).squareShape;
    const currVal_25:any = import0.ɵnov(v,25).roundedShape;
    const currVal_26:any = import0.ɵnov(v,25).ovalShape;
    const currVal_27:any = import0.ɵnov(v,25).flatStyle;
    const currVal_28:any = import0.ɵnov(v,25).outlineStyle;
    const currVal_29:any = import0.ɵnov(v,25).raisedStyle;
    const currVal_30:any = import0.ɵnov(v,25).verticalLayout;
    const currVal_31:any = import0.ɵnov(v,25).horizontalLayout;
    ck(v,24,1,[
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27,
      currVal_28,
      currVal_29,
      currVal_30,
      currVal_31
    ]
    );
  });
}
function View_MarketingEntryPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-marketing-entry-page',([] as any[]),(null as any),(null as any),(null as any),View_MarketingEntryPageComponent_0,RenderType_MarketingEntryPageComponent)),
    import0.ɵdid(49152,(null as any),0,import14.MarketingEntryPageComponent,[
      import24.NavigationParams,
      import13.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import12.Page,(null as any),[import14.MarketingEntryPageComponent])
  ]
  ,(null as any),(null as any));
}
export const MarketingEntryPageComponentNgFactory:import0.ComponentFactory<import14.MarketingEntryPageComponent> = import0.ɵccf('woa-marketing-entry-page',import14.MarketingEntryPageComponent,View_MarketingEntryPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/customer-info/marketing-entry-page/marketing-entry-page.component.ngfactory.ts